import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/nominas/solicitud-de-contratacion-pruebas-y-otros-sin-paginado/';
/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSolicitudPruebas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSolicitudPrueba = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */

export const postSolicitudPrueba = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSolicitudPrueba = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSolicitudPrueba = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarSolicitudPrueba = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET - Catálogo de Estados de Candidato
 * @returns {Promise<object[]>}
 */
export const getPruebas = async () => {
  try {
    const response = await API.get('/catalogos/pruebas-y-otros/');
    return response.data || [];
  } catch (err) {
    onError(err);
    return [];
  }
};

export const baseURIPruebasYOtros = '/catalogos/pruebas-y-otros/';

/**
 * GET - Catálogo Pruebas y Otros
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPruebasYOtros = async (params) => {
  try {
    const response = await API.get(baseURIPruebasYOtros, { params });
    return response.data || [];
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPruebaYOtro = async (id) => {
  try {
    const response = await API.get(`${baseURIPruebasYOtros}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPruebaYOtro = async (values) => {
  try {
    const response = await API.post(baseURIPruebasYOtros, values);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPruebaYOtro = async (id, values) => {
  try {
    const response = await API.patch(`${baseURIPruebasYOtros}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePruebaYOtro = async (id) => {
  try {
    const response = await API.delete(`${baseURIPruebasYOtros}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
